module.exports = __webpack_public_path__ + "static/media/stack_zephyr.f310ad2a.png";